'use client'

import React, { useState, useRef } from 'react'
import { Container } from '@quark/layout'
import { Text } from '@quark/typography'
import { Reveal } from '@quark/animation'
import BusinessModals from '@components/BusinessModal/businessModals'
import BenefitsCard from '../Card'
import styles from '../../benefitsCarousal.module.scss'

interface VerticalViewProps {
  title?: string
  benefitCards?: any[]
}

const VerticalView = ({ title, benefitCards }: VerticalViewProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [formSnippet, setFormSnippet] = useState<string>('')
  const cardRefs = useRef<Array<HTMLDivElement | null>>([])

  return (
    <Container
      type="fluid"
      paddingTop={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}
      backgroundColor="base/overlay">
      <Container type="fluid" position="relative">
        <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 100 }}>
          <Container
            type="max-parent"
            paddingBottom={{ lg: 'spacing-64', md: 'spacing-48', sm: 'spacing-32' }}
            px={{ sm: 'spacing-20' }}>
            <Text
              as="h1"
              fontStyle={{ lg: 'um_text-5xl/bold', md: 'um_text-4xl/bold', sm: 'um_text-3xl/bold' }}
              color="base/primary"
              textAlign={{ lg: 'center', md: 'center', sm: 'center' }}
              dangerouslySetInnerHTML={{ __html: title || '' }}
            />
          </Container>
        </Reveal>

        <Container type="root" paddingBottom="spacing-40">
          {benefitCards?.map((card, index) => (
            <div
              key={index}
              ref={el => {
                cardRefs.current[index] = el
              }}
              className={styles.benefitsCardContainer}>
              <div className={styles.benefitsCard}>
                <BenefitsCard data={card} setIsModalOpen={setIsModalOpen} setFormSnippet={setFormSnippet} />
              </div>
            </div>
          ))}
        </Container>
      </Container>
      <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />
    </Container>
  )
}

export default VerticalView
